/**
 * The link that opens "invite someone" (bug bash SW-7): the welcome email's
 * "Invitar a alguien" button. `/in/<org>/people?invite=1` opens the invite
 * dialog of Personas in Encuentro; classic redirects it to the directory
 * (`?tab=directory&invite=1`), where the dashboard shell opens its own
 * invite dialog. Welcome emails sent before carried `/in/<org>?invite=true`,
 * which both interfaces still honour.
 *
 * Opening it never invites anyone by itself, and a member who may not
 * invite (lib/referrals/permission.ts) just lands on the page.
 */
export const INVITE_LINK_PARAM = 'invite'

export function inviteLinkPath(orgSlug: string): string {
  return `/in/${orgSlug}/people?${INVITE_LINK_PARAM}=1`
}

/** `?invite=1` and the older `?invite=true`. */
export function isInviteLinkValue(value: string | null | undefined): boolean {
  const normalized = value?.trim().toLowerCase()
  return normalized === '1' || normalized === 'true'
}
